export const GET_APPOINTMENT_LIST = "GET_APPOINTMENT_LIST";

export const GET_RESOURCE_LIST = "GET_RESOURCE_LIST";

export const GET_WAIT_LIST = "GET_WAIT_LIST";

export const GET_APPOINTMENT_DETAIL = "GET_APPOINTMENT_DETAIL";

export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";

export const UPDATE_STATUS = "UPDATE_STATUS";

export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";

export const RELOAD_CALENDAR = "RELOAD_CALENDAR";

export const SELECT_RESOURCE = "SELECT_RESOURCE";

export const GET_FILTERED_LIST = "GET_FILTERED_LIST";

export const CREATE_BLOCK_TIME = "CREATE_BLOCK_TIME";

export const DELETE_BLOCK_TIME = "DELETE_BLOCK_TIME";

export const CHECKOUT = "CHECKOUT";

export const GET_APPOINTMENT_SPECIFIC_DATE = "GET_APPOINTMENT_SPECIFIC_DATE";

export const CHECK_UPDATE = "CHECK_UPDATE";

export const GET_LIST_SEARCH = "GET_LIST_SEARCH";

export const DRAG_DROP_UPDATE = "DRAG_DROP_UPDATE";

export const CREATE_ORDER = "CREATE_ORDER";